const Input = ({ label, name, formik, type, disabled, reqiuerd }) => {
  return (
    <div className="w-full flex flex-col h-24">
      <label className="mb-2 text-sm" htmlFor={name}>
        {label} {reqiuerd ? <span className="text-red-700">*</span> : ""}
      </label>
      <input
        inputmode={type === "number" ? "decimal" : "text"}
        id={name}
        type={type}
        {...formik.getFieldProps({ name })}
        name={name}
        disabled={disabled}
        className="border border-stone-200 h-10 rounded px-2 focus:outline-lightGreenKite"
      />
      {formik.errors[name] && formik.touched[name] && (
        <div className="text-xs text-orangeKite mt-1">
          {formik.errors[name]}
        </div>
      )}
    </div>
  );
};

export default Input;
